<div class="panel panel-info">
  <div class="panel-heading" (click)="toggle.emit()">
    <i class="fas fa-chevron-down" *ngIf="opened"></i>
    <i class="fas fa-chevron-right" *ngIf="!opened"></i>
    {{title}}
  </div>
  <div class="panel-body" *ngIf="opened">
    <ng-content></ng-content>
  </div>
</div>